import { get, post } from '../axios'

// 分配实验层流量
export function post_abLayer_new_allocate(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abLayer/new/allocate`, map)
}

// 分页查询
export function post_abLayer_new_page(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abLayer/new/page`, map)
}

// 查询所有实验层
export function post_abLayer_new_queryAll(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abLayer/new/queryAll`, map)
}

// 删除实验层
export function get_abLayer_new_remove(map) {
  return get(`${process.env.VUE_APP_ABTEST}/abLayer/new/remove`, map)
}

// 保存实验层
export function post_abLayer_new_save(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abLayer/new/save`, map)
}
